export const SIGN_IN_UNAVAILABLE_MESSAGE = 'Unable to sign in right now, please try again';
export const SSO_SIGN_IN_FAILED_MESSAGE = 'Sign in was unsuccessful, please try again';
export const NO_CONTRACT_BUILDER_ACCESS_MESSAGE =
  "You don't have access to Contract Builder. Contact your administrator if you believe this is a mistake";
export const INCORRECT_CREDENTIALS_MESSAGE = 'Incorrect email or password';
export const SIGN_IN_THROTTLED_MESSAGE = 'Too many attempts, please try again later';

// Cognito's LimitExceededException message for this flow — checked verbatim rather than
// generically, so throttling isn't confused with a wrong-password/no-account error (which would
// leak account existence, see CB-3058 spec).
export const isThrottledError = (message?: string) => message === 'Attempt limit exceeded, please try after some time.';
